import React from 'react';

/** Marca d'água da empresa proprietária em todo o fundo da tela de login. */
export function OwnerLoginWatermark({ iconUrl }) {
  const url = (iconUrl || '').trim();
  if (!url || (!url.startsWith('http') && !url.startsWith('/'))) {
    return null;
  }

  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      <img
        src={url}
        alt=""
        style={{
          width: 'min(92vw, 900px)',
          height: 'min(92vh, 900px)',
          objectFit: 'contain',
          opacity: 0.07,
          userSelect: 'none',
        }}
      />
    </div>
  );
}
